// AOS
import AOS from 'aos';
window.AOS = AOS;
import 'aos/dist/aos.css';

// Image Compare
import ImageCompare from 'image-compare-viewer';
window.ImageCompare = ImageCompare;
import 'image-compare-viewer/dist/image-compare-viewer.min.css';

// Typed.js
import Typed from 'typed.js';
window.Typed = Typed;

// CountUp.js
import { CountUp } from 'countup.js';
window.CountUp = CountUp;

// Floating UI
import { computePosition, flip, shift, offset, arrow } from "@floating-ui/dom";
if (typeof window.FloatingUIDOM == 'undefined') { window.FloatingUIDOM = {}; }
window.FloatingUIDOM = {};
window.FloatingUIDOM.computePosition = computePosition;
window.FloatingUIDOM.flip = flip;
window.FloatingUIDOM.shift = shift;
window.FloatingUIDOM.offset = offset;
window.FloatingUIDOM.arrow = arrow;
